import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        authenticated: true
      }
    },
    // {
    //   path: '/catalogue',
    //   name: 'Home',
    //   component: Home
    // },
    // {
    //   path: '/recommendations',
    //   name: 'Recommendations',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "Recommendations" */ './views/Recommendations.vue'
    //     )
    // },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "Login" */ './views/Login.vue')
    },
    // Self-registration disabled - users must be created by tenant admin
    // {
    //   path: '/register',
    //   name: 'Register',
    //   component: () =>
    //     import(/* webpackChunkName: "Register" */ './views/Register.vue')
    // },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () =>
        import(
          /* webpackChunkName: "ForgotPassword" */ './views/ForgotPassword.vue'
        )
    },
    {
      path: '/reset-password/:key',
      name: 'ResetPassword',
      component: () =>
        import(
          /* webpackChunkName: "ResetPassword" */ './views/ResetPassword.vue'
        )
    },
    {
      path: '/change-password',
      name: 'ChangePassword',
      component: () =>
        import(
          /* webpackChunkName: "ChangePassword" */ './views/ChangePassword.vue'
        ),
      meta: {
        authenticated: true,
        verified: true
      }
    },
    {
      path: '/edit-profile',
      name: 'EditProfile',
      component: () =>
        import(/* webpackChunkName: "EditProfile" */ './views/EditProfile.vue'),
      meta: {
        authenticated: true,
        verified: true
      }
    },
    // {
    //   path: '/content-requirements',
    //   name: 'ContentRequirements',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "ContentRequirements" */ './views/ContentRequirements.vue'
    //     ),
    //   meta: {
    //     authenticated: true,
    //     verified: true,
    //     roles: ['buyer']
    //   }
    // },
    {
      path: '/manage-media',
      name: 'ManageMedia',
      component: () =>
        import(/* webpackChunkName: "ManageMedia" */ './views/ManageMedia.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['traffic', 'admin', 'scheduler']
      }
    },
    {
      path: '/edit-media/:id',
      name: 'EditMedia',
      component: () =>
        import(/* webpackChunkName: "EditMedia" */ './views/EditMedia.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['traffic', 'admin']
      }
    },
    {
      path: '/admin/manage-packages',
      name: 'ManagePackages',
      component: () =>
        import(
          /* webpackChunkName: "ManagePackages" */ './views/ManagePackages.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/manage-package-titles/:id',
      name: 'ManagePackageTitles',
      component: () =>
        import(
          /* webpackChunkName: "ManagePackageTitles" */ './views/ManagePackageTitles.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/edit-package/:id',
      name: 'EditPackage',
      component: () =>
        import(/* webpackChunkName: "EditPackage" */ './views/EditPackage.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/create-package',
      name: 'CreatePackage',
      component: () =>
        import(/* webpackChunkName: "EditPackage" */ './views/EditPackage.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/manage-episodes/:id',
      name: 'ManageEpisodes',
      component: () =>
        import(
          /* webpackChunkName: "ManageEpisodes" */ './views/ManageEpisodes.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['traffic', 'admin']
      }
    },
    {
      path: '/manage-metadata',
      name: 'ManageMetadata',
      component: () =>
        import(
          /* webpackChunkName: "ManageMetadata" */ './views/ManageMetadata.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/edit-episode/:id',
      name: 'EditEpisode',
      component: () =>
        import(/* webpackChunkName: "EditEpisode" */ './views/EditEpisode.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['traffic', 'admin']
      }
    },
    {
      path: '/create-episode/:id',
      name: 'CreateEpisode',
      component: () =>
        import(/* webpackChunkName: "EditEpisode" */ './views/EditEpisode.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['traffic', 'admin']
      }
    },
    {
      path: '/manage-organisations',
      name: 'ManageOrganisations',
      component: () =>
        import(
          /* webpackChunkName: "ManageOrganisations" */ './views/ManageOrganisations.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['superadmin']
      }
    },
    {
      path: '/edit-organisation/:id',
      name: 'EditOrganisation',
      component: () =>
        import(
          /* webpackChunkName: "EditOrganisation" */ './views/EditOrganisation.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['superadmin']
      }
    },
    {
      path: '/create-organisation',
      name: 'CreateOrganisation',
      component: () =>
        import(
          /* webpackChunkName: "EditOrganisation" */ './views/EditOrganisation.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['superadmin']
      }
    },
    {
      path: '/create-media',
      name: 'CreateMedia',
      component: () =>
        import(/* webpackChunkName: "EditMedia" */ './views/EditMedia.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['traffic', 'admin']
      }
    },
    // Cart functionality removed - legacy buyers platform feature
    // {
    //   path: '/cart/:id?',
    //   name: 'CartByList',
    //   component: () =>
    //     import(/* webpackChunkName: "Cart" */ './views/Cart.vue'),
    //   meta: {
    //     authenticated: true,
    //     verified: true,
    //     roles: ['buyer']
    //   }
    // },
    {
      path: '/admin/manage-home-page',
      name: 'ManageHomePage',
      component: () =>
        import(
          /* webpackChunkName: "ManageHomePage" */ './views/ManageHomePage.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/manage-users/:id',
      name: 'ManageUsersByOrganisation',
      component: () =>
        import(/* webpackChunkName: "ManageUsers" */ './views/ManageUsers.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['superadmin']
      }
    },
    {
      path: '/admin/manage-users',
      name: 'ManageUsers',
      component: () =>
        import(/* webpackChunkName: "ManageUsers" */ './views/ManageUsers.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/audit-logs',
      name: 'AuditLogs',
      component: () =>
        import(/* webpackChunkName: "AuditLogs" */ './views/AuditLogs.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/report-issue',
      name: 'ReportIssue',
      component: () =>
        import(/* webpackChunkName: "ReportIssue" */ './views/ReportIssue.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/create-user',
      name: 'CreateUser',
      component: () =>
        import(/* webpackChunkName: "CreateUser" */ './views/CreateUser.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/manage-cart/:id',
      name: 'ManageCart',
      component: () =>
        import(/* webpackChunkName: "ManageCart" */ './views/ManageCart.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/manage-cart/:id/:collectionid?',
      name: 'ManageCartByList',
      component: () =>
        import(
          /* webpackChunkName: "ManageCartByList" */ './views/ManageCart.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/manage-recommendations/:id',
      name: 'ManageRecommendations',
      component: () =>
        import(
          /* webpackChunkName: "ManageRecommendations" */ './views/ManageRecommendations.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/edit-user/:id',
      name: 'UpdateUser',
      component: () =>
        import(/* webpackChunkName: "UpdateUser" */ './views/UpdateUser.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/update-password/:id',
      name: 'AdminChangePassword',
      component: () =>
        import(
          /* webpackChunkName: "AdminChangePassword" */ './views/AdminChangePassword.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/manage-media',
      name: 'ManageAllMedia',
      component: () =>
        import(
          /* webpackChunkName: "ManageAllMedia" */ './views/ManageAllMedia.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/verify-email',
      name: 'VerifyEmail',
      component: () =>
        import(/* webpackChunkName: "VerifyEmail" */ './views/VerifyEmail.vue'),
      meta: {
        authenticated: true
      }
    },
    {
      path: '/email-verified/:key',
      name: 'EmailVerified',
      component: () =>
        import(
          /* webpackChunkName: "EmailVerified" */ './views/EmailVerified.vue'
        )
    },
    {
      path: '/contact-us',
      name: 'Contact',
      component: () =>
        import(/* webpackChunkName: "Contact" */ './views/Contact.vue')
    },
    // {
    //   path: '/title-supplier-request',
    //   name: 'TitleSupplierRequest',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "TitleSupplierRequest" */ './views/TitleSupplierRequest.vue'
    //     ),
    //   meta: {
    //     authenticated: true
    //   }
    // },
    {
      path: '/media/:id',
      name: 'MediaDetail',
      component: () =>
        import(/* webpackChunkName: "MediaDetail" */ './views/MediaDetail.vue')
    },
    {
      path: '/import-media',
      name: 'ImportMedia',
      component: () =>
        import(/* webpackChunkName: "ImportMedia" */ './views/ImportMedia.vue')
    },
    {
      path: '/import-media-file',
      name: 'ImportMediaFile',
      component: () =>
        import(
          /* webpackChunkName: "ImportMediaFile" */ './views/ImportMediaFile.vue'
        )
    },
    {
      path: '/meta/:type/:id',
      name: 'Metadata',
      component: () =>
        import(/* webpackChunkName: "Metadata" */ './views/Metadata.vue')
    },
    {
      path: '/meta-multi/:id1/:id2',
      name: 'MetadataMulti',
      component: () =>
        import(/* webpackChunkName: "Metadata" */ './views/Metadata.vue')
    },
    // {
    //   path: '/packages',
    //   name: 'Packages',
    //   component: () =>
    //     import(/* webpackChunkName: "Packages" */ './views/Packages.vue'),
    //   meta: {
    //     authenticated: true
    //   }
    // },
    // {
    //   path: '/package/:id',
    //   name: 'PackageDetail',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "PackageDetail" */ './views/PackageDetail.vue'
    //     ),
    //   meta: {
    //     authenticated: true
    //   }
    // },
    {
      path: '/admin/channels',
      name: 'ManageChannels',
      component: () =>
        import(
          /* webpackChunkName: "ManageChannels" */ './views/ManageChannels.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin', 'traffic']
      }
    },
    {
      path: '/admin/edit-channel/:id',
      name: 'EditChannel',
      component: () =>
        import(/* webpackChunkName: "EditChannel" */ './views/EditChannel.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin']
      }
    },
    {
      path: '/admin/storage',
      name: 'ManageStorage',
      component: () =>
        import(
          /* webpackChunkName: "ManageStorage" */ './views/ManageStorage.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/workflow-chains',
      name: 'MediaProcessing',
      component: () =>
        import(
          /* webpackChunkName: "MediaProcessing" */ './components/MediaProcessing.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['admin']
      }
    },
    {
      path: '/admin/create-channel',
      name: 'CreateChannel',
      component: () =>
        import(/* webpackChunkName: "EditChannel" */ './views/EditChannel.vue'),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin']
      }
    },
    {
      path: '/admin/edit-schedule/:id',
      name: 'EditSchedule',
      component: () =>
        import(
          /* webpackChunkName: "EditSchedule" */ './views/EditSchedule.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin', 'traffic']
      }
    },
    {
      path: '/admin/channel-viewing-slots/:id',
      name: 'ManageChannelViewingSlots',
      component: () =>
        import(
          /* webpackChunkName: "ManageChannelViewingSlots" */ './views/ManageChannelViewingSlots.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin']
      }
    },
    {
      path: '/admin/create-channel-viewing-slot/:id',
      name: 'CreateChannelViewingSlot',
      component: () =>
        import(
          /* webpackChunkName: "EditChannelViewingSlot" */ './views/EditChannelViewingSlot.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin']
      }
    },
    {
      path: '/admin/edit-channel-viewing-slot/:id',
      name: 'EditChannelViewingSlot',
      component: () =>
        import(
          /* webpackChunkName: "EditChannelViewingSlot" */ './views/EditChannelViewingSlot.vue'
        ),
      meta: {
        authenticated: true,
        verified: true,
        roles: ['scheduler', 'admin']
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: () =>
        import(/* webpackChunkName: "Search" */ './views/Search.vue')
    },
    {
      path: '/about',
      name: 'About',
      component: () =>
        import(/* webpackChunkName: "About" */ './views/About.vue')
    },
    {
      path: '/how-it-works',
      name: 'HowItWorks',
      component: () =>
        import(/* webpackChunkName: "HowItWorks" */ './views/HowItWorks.vue')
    },
    {
      path: '/legal',
      name: 'Legal',
      component: () =>
        import(/* webpackChunkName: "Legal" */ './views/Legal.vue')
    },
    {
      path: '/*',
      component: () =>
        import(/* webpackChunkName: "NotFound" */ './views/NotFound.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
